// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js!../all-products/components/CashDrawerModal/CashDrawerModal.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling the react-select control to match cash-drawer-select */
.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__control {
  border-radius: 12px !important;
  font-size: 0.875rem !important;
  background-color: transparent !important;
  height: 44px !important;
  min-height: 44px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
  box-sizing: border-box !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
}

.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__control:hover {
  border-color: #cbd5e1 !important;
}

.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__control--is-focused {
  border-color: #2563eb !important;
  box-shadow: 0 0 0 1px #2563eb !important;
}

/* Dark mode select styles */
.cash-drawer-modal-container.dark .soft-select-wrapper-I .soft-select__control {
  border-color: #475569 !important;
}

.cash-drawer-modal-container.dark .soft-select-wrapper-I .soft-select__control:hover {
  border-color: #64748b !important;
}

.cash-drawer-modal-container.dark .soft-select-wrapper-I .soft-select__control--is-focused {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 1px #3b82f6 !important;
}

/* Placeholder and text color inside select */
.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__single-value {
  color: #0f172a !important;
  font-size: 0.875rem !important;
}

.cash-drawer-modal-container.dark .soft-select-wrapper-I .soft-select__single-value {
  color: #ffffff !important;
}

.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__placeholder {
  color: #94a3b8 !important;
  opacity: 1 !important;
}

/* Dropdown Menu (popover) styling */
.soft-select__menu {
  border-radius: 12px !important;
  margin-top: 4px !important;
  box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1) !important;
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  z-index: 9999 !important;
}

.cash-drawer-modal-container.dark .soft-select__menu {
  border: 1px solid #475569 !important;
  background-color: #1e293b !important;
}

/* Options */
.soft-select__option {
  font-size: 0.875rem !important;
  padding: 8px 16px !important;
  background-color: transparent !important;
  color: #0f172a !important;
  cursor: pointer !important;
}

.cash-drawer-modal-container.dark .soft-select__option {
  color: #ffffff !important;
}

.soft-select__option--is-focused {
  background-color: #f1f5f9 !important;
}

.cash-drawer-modal-container.dark .soft-select__option--is-focused {
  background-color: #334155 !important;
}

.soft-select__option--is-selected {
  background-color: #e0f2fe !important;
  color: #0369a1 !important;
}

.cash-drawer-modal-container.dark .soft-select__option--is-selected {
  background-color: #2563eb !important;
  color: #ffffff !important;
}

/* Scrollbar inside menu list */
.soft-select__menu-list::-webkit-scrollbar {
  width: 6px;
}
.soft-select__menu-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 12px;
}
.cash-drawer-modal-container.dark .soft-select__menu-list::-webkit-scrollbar-track {
  background: #1e293b;
}
.soft-select__menu-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 12px;
}
.cash-drawer-modal-container.dark .soft-select__menu-list::-webkit-scrollbar-thumb {
  background: #475569;
}

/* Actions layout */
.cash-drawer-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 10px;
}

.cash-drawer-cancel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 12px;
  color: #64748b;
  border: 1px solid #e2e8f0;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s, transform 0.1s;
}

.cash-drawer-modal-container.dark .cash-drawer-cancel-btn {
  color: #94a3b8;
  border-color: #475569;
}

.cash-drawer-cancel-btn:hover {
  background-color: #f1f5f9;
}

.cash-drawer-modal-container.dark .cash-drawer-cancel-btn:hover {
  background-color: #334155;
}

.cash-drawer-cancel-btn:active {
  transform: scale(0.98);
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/hooks/useAuthModal.css"],"names":[],"mappings":"AAEA,iEAAiE;AACjE;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,sDAAsD;EACtD,iCAAiC;EACjC,qEAAqE;AACvE;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,wFAAwF;EACxF,oCAAoC;EACpC,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,wCAAwC;EACxC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["@import \"../all-products/components/CashDrawerModal/CashDrawerModal.css\";\n\n/* Styling the react-select control to match cash-drawer-select */\n.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__control {\n  border-radius: 12px !important;\n  font-size: 0.875rem !important;\n  background-color: transparent !important;\n  height: 44px !important;\n  min-height: 44px !important;\n  border: 1px solid #e2e8f0 !important;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;\n  box-sizing: border-box !important;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease !important;\n}\n\n.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__control:hover {\n  border-color: #cbd5e1 !important;\n}\n\n.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__control--is-focused {\n  border-color: #2563eb !important;\n  box-shadow: 0 0 0 1px #2563eb !important;\n}\n\n/* Dark mode select styles */\n.cash-drawer-modal-container.dark .soft-select-wrapper-I .soft-select__control {\n  border-color: #475569 !important;\n}\n\n.cash-drawer-modal-container.dark .soft-select-wrapper-I .soft-select__control:hover {\n  border-color: #64748b !important;\n}\n\n.cash-drawer-modal-container.dark .soft-select-wrapper-I .soft-select__control--is-focused {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 1px #3b82f6 !important;\n}\n\n/* Placeholder and text color inside select */\n.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__single-value {\n  color: #0f172a !important;\n  font-size: 0.875rem !important;\n}\n\n.cash-drawer-modal-container.dark .soft-select-wrapper-I .soft-select__single-value {\n  color: #ffffff !important;\n}\n\n.cash-drawer-modal-container .soft-select-wrapper-I .soft-select__placeholder {\n  color: #94a3b8 !important;\n  opacity: 1 !important;\n}\n\n/* Dropdown Menu (popover) styling */\n.soft-select__menu {\n  border-radius: 12px !important;\n  margin-top: 4px !important;\n  box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1) !important;\n  border: 1px solid #e2e8f0 !important;\n  background-color: #ffffff !important;\n  z-index: 9999 !important;\n}\n\n.cash-drawer-modal-container.dark .soft-select__menu {\n  border: 1px solid #475569 !important;\n  background-color: #1e293b !important;\n}\n\n/* Options */\n.soft-select__option {\n  font-size: 0.875rem !important;\n  padding: 8px 16px !important;\n  background-color: transparent !important;\n  color: #0f172a !important;\n  cursor: pointer !important;\n}\n\n.cash-drawer-modal-container.dark .soft-select__option {\n  color: #ffffff !important;\n}\n\n.soft-select__option--is-focused {\n  background-color: #f1f5f9 !important;\n}\n\n.cash-drawer-modal-container.dark .soft-select__option--is-focused {\n  background-color: #334155 !important;\n}\n\n.soft-select__option--is-selected {\n  background-color: #e0f2fe !important;\n  color: #0369a1 !important;\n}\n\n.cash-drawer-modal-container.dark .soft-select__option--is-selected {\n  background-color: #2563eb !important;\n  color: #ffffff !important;\n}\n\n/* Scrollbar inside menu list */\n.soft-select__menu-list::-webkit-scrollbar {\n  width: 6px;\n}\n.soft-select__menu-list::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 12px;\n}\n.cash-drawer-modal-container.dark .soft-select__menu-list::-webkit-scrollbar-track {\n  background: #1e293b;\n}\n.soft-select__menu-list::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 12px;\n}\n.cash-drawer-modal-container.dark .soft-select__menu-list::-webkit-scrollbar-thumb {\n  background: #475569;\n}\n\n/* Actions layout */\n.cash-drawer-actions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.cash-drawer-cancel-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 48px;\n  font-size: 1rem;\n  font-weight: 700;\n  border-radius: 12px;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n  background-color: transparent;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s, transform 0.1s;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-cancel-btn {\n  color: #94a3b8;\n  border-color: #475569;\n}\n\n.cash-drawer-cancel-btn:hover {\n  background-color: #f1f5f9;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-cancel-btn:hover {\n  background-color: #334155;\n}\n\n.cash-drawer-cancel-btn:active {\n  transform: scale(0.98);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
